/**
 * Sentry Constants
 * Standardized error levels and tag names for consistent Sentry usage
 */

export const ERROR_LEVELS = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
} as const;

export const TAGS = {
  ERROR_TYPE: 'error_type',
  HTTP_STATUS: 'http_status',
  HTTP_METHOD: 'http_method',
  API_TYPE: 'api_type',
  ERROR_CODE: 'error_code',
} as const;
